import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import {




  BehaviorSubject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  merge,
  of,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
} from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { IAEventDocumentDetails } from '../../../../../shared/models/IAEventDocumentDetails';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { IAEventAttendanceDetails } from '../../../../../shared/models/IAEventAttendanceDetails';
import { ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { co } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-update-msme-attendance-popup',
  templateUrl: './update-msme-attendance-popup.component.html',
  styleUrl: './update-msme-attendance-popup.component.css',
})
export class UpdateMsmeAttendancePopupComponent implements OnInit {
  private loadEventAttendanceSubscription: Subscription | null = null;
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  eventMarkAttendanceForm: FormGroup;
  eventId: any;
  uploadError: string | null = null;
  fileErrors: { typeError: boolean; sizeError: boolean } = {
    typeError: false,
    sizeError: false,
  };
  removedocumentuploadError: string | null = null;
  uploadAttError: string | null = null;
  result: any[] = [];
  data: any = {};
  //reportData: any[] = [];
  UniqueEventId: string = '';
  uniqueEventId: any;

  selectedParticipants: IAEventAttendanceDetails[] = [];
  existingParticipants: string[] = [];

  allSelectedParticipants: string[] = [];

  showNoParticipantsMessage: boolean = false;

  selectedItems: any[] = []; // To store selected items
  document: { name: string; file: File | null }[] = [];
  attendanc: { name: string; file: File | null }[] = [];
  isSubmitted = false;
  AttendanceDetailsData: any[] = [];
  DocumentDetailsData: any[] = [];
  msMeUserName = sessionStorage.getItem('userId');
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  declarationAccepted: boolean = false;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination = {
    UniqueEventId: '',

    PageNumber: 1,
    PageSize: 20,
    SortColumn: '',
    SortDirection: '',
    SearchTerm: '',
    SearchCol: '',
  };
  dataSource!: MatTableDataSource<IAEventDocumentDetails>;
  //displayedColumns: string[] = ['Sr.No', 'IAUserName', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download']
  displayedColumns: string[] = [
    'SrNo',
    'DocumentType',
    'CreatedDate',
    'DocumentName',
    'Download',
    'Remove',
  ];

  dataSourceattendance!: MatTableDataSource<IAEventAttendanceDetails>;
  displayedAttendanceColumns: string[] = [
    'SrNo',
    'UdyamRegistrationNumber',
    'EnterpriseName',
    'ParticipantName',
    'MobileNumber',
    'EnrollmentId',
    'CreatedDate',
  ];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  EventId:any;
  isAttendanceSubmitted: boolean = false;

  constructor(
    private apiService: ApiService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private cdRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public datapopup: any,
     private dialogRef: MatDialogRef<UpdateMsmeAttendancePopupComponent>,
  ) {
    this.eventMarkAttendanceForm = this.fb.group({
      declarationAccepted: this.fb.control(false),
      selectedParticipants: this.fb.array([]), // FormArray to hold selected rows
    });
    console.log('Received data in popup:', datapopup);
    this.route.params.subscribe((params) => {
      this.eventId = datapopup.element['UniqueEventId'];
      this.EventId = datapopup.element['EventId'];
    });
  }

  get f() {
    return this.eventMarkAttendanceForm.controls;
  }

  ngOnInit() {
    this.GetEventParticipants();
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
  }
  ngAfterViewInit() {
    // this.loadEventIAAttendanceWithUdyamDetails();
  }

  //previous
  onSubmit(key: string) {
    //this.eventId;

    if (key === 'submit') {
      if (
        window.confirm(
          'Are you sure you want to submit the attendance? Once it is submitted no further change will be allowed',
        )
      ) {
        this.onSubmitForSubmitButton('submit');
      } else {
        console.log('Submission canceled.');
      }
    } else {
      //this.isSubmitted = true;
      if (this.eventMarkAttendanceForm.valid) {
        const formData = new FormData();
        let participantIndex = 0; // Use a single, running index for all participants

        const declarationAccepted = this.eventMarkAttendanceForm.get(
          'declarationAccepted',
        )?.value;

        // Always append existingParticipants first
        this.existingParticipants.forEach((participant: any) => {
          formData.append(
            `selectedParticipants[${participantIndex}].UdyamRegistrationNumber`,
            participant.UdyamRegistrationNumber,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].ParticipantName`,
            participant.ParticipantName,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].NameOfEnterprise`,
            participant.NameOfEnterprise,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].MobileNumber`,
            participant.MobileNumber,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].EnrollmentId`,
            participant.EnrollmentId,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].IsChecked`,
            participant.IsChecked,
          );
          participantIndex++;
        });

        // If selectedParticipants is not empty, append them as well
        if (this.selectedParticipants.length > 0) {
          this.selectedParticipants.forEach((participant: any) => {
            formData.append(
              `selectedParticipants[${participantIndex}].UdyamRegistrationNumber`,
              participant.UdyamRegistrationNumber,
            );
            formData.append(
              `selectedParticipants[${participantIndex}].ParticipantName`,
              participant.ParticipantName,
            );
            formData.append(
              `selectedParticipants[${participantIndex}].NameOfEnterprise`,
              participant.NameOfEnterprise,
            );
            formData.append(
              `selectedParticipants[${participantIndex}].MobileNumber`,
              participant.MobileNumber,
            );
            formData.append(
              `selectedParticipants[${participantIndex}].EnrollmentId`,
              participant.EnrollmentId,
            );
            formData.append(
              `selectedParticipants[${participantIndex}].IsChecked`,
              participant.IsChecked,
            );
            participantIndex++;
          });
        }

        formData.append('UniqueEventId', this.eventId);

        formData.append('key', key);

        formData.append('declarationAccepted', declarationAccepted);




        this.apiService
          .postRequest(API_ENDPOINTS.MSSIDC.SAVE_MSSIDC_EVENT_ATTENDANCE, formData)
          .subscribe((result: any) => {
            this.toastrService.success(
              'Attendance marked successfully!',
              'Record Added!',
            );
            // this.router.navigate(['/Msme-Attendance']);
           
          });
      } else {
        this.eventMarkAttendanceForm.markAllAsTouched();
        return;
      }
    }
  }

  GetEventParticipants() {
    this.apiService
      .getRequest(API_ENDPOINTS.IA.GETEVENTSPARTICIPANTSDETAILS, {
        UniqueEventId: this.eventId,
      })
      .subscribe((result) => {
        // Get a reference to the control once
        const declarationControl = this.eventMarkAttendanceForm.get(
          'declarationAccepted',
        );
        if (result.status) {
          if (result.message == 'No Participants') {
            this.showNoParticipantsMessage = true;

            if (declarationControl) {
              declarationControl.setValidators(Validators.requiredTrue);
              declarationControl.updateValueAndValidity(); // Apply validation immediately
            }
          } else {
this.reportData = result.data;

// ✅ Normalize + create fast lookup
const feedbackSet = new Set(
  this.datapopup.feedbacklist.map((f: any) =>
    (f.udyamRegistrationNumber || '')
      .trim()
      .toLowerCase()
  )
);

this.reportData = this.reportData.map((participant: any) => ({
  ...participant,
  isDisabled: feedbackSet.has(
    (participant.UdyamRegistrationNumber || '')
      .trim()
      .toLowerCase()
  )
}));

// ✅ Existing checked participants
this.existingParticipants = this.reportData.filter(
  (participant: any) => participant.IsChecked === true
);

// ✅ Debug (optional)
console.log('Report Data with disable flags:', this.reportData);
console.log('Feedback List:', this.datapopup.feedbacklist);
console.log('Existing Participants:', this.existingParticipants);

            

            // Crucial: Remove the validator if data IS present
            if (declarationControl) {
              declarationControl.setValidators(null);
              declarationControl.updateValueAndValidity(); // Apply change
            }
          }
        }
      });
  }

  onCheckboxChange(event: any, item: any) {
    const inputElement = event.target as HTMLInputElement;
    const isChecked = inputElement.checked;
    item.IsChecked = isChecked; // Update the IsChecked property in the reportData

    // Update the selectedParticipants array
    const existingIndex = this.selectedParticipants.findIndex(
      (p) => p.EnrollmentId === item.EnrollmentId,
    );

    if (existingIndex > -1) {
      // If the item exists, update its IsChecked status
      this.selectedParticipants[existingIndex] = { ...item };
    } else {
      // If the item doesn't exist, add it
      this.selectedParticipants.push({ ...item });
    }

    console.log(this.selectedParticipants);
  }

  loadEventIAAttendanceWithUdyamDetails() {
    this.DtoPagination.UniqueEventId = this.eventId;

    // Unsubscribe from previous subscription to prevent multiple API calls
    if (this.loadEventAttendanceSubscription) {
      this.loadEventAttendanceSubscription.unsubscribe();
    }

    this.loadEventAttendanceSubscription = this.apiService
      .getRequest(
        API_ENDPOINTS.IA.GETEVENTIAATTENDANCEWITHUDYAM,
        this.DtoPagination,
      )
      .pipe(
        catchError(() => of(null)), // Handle errors gracefully
        map((resp) => {
          return resp?.data || {}; // Extract data from response
        }),
      )
      //.subscribe(data => {
      //  this.AttendanceDetailsData = data;
      //});
      .subscribe((data: any[]) => {
        this.AttendanceDetailsData = data.map((item: any) => ({
          ...item,
          isChecked: !!item.isChecked, // Ensure null or undefined values convert to false
        }));
      });
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }
  onSubmitForSubmitButton(key: string) {
    //this.isSubmitted = true;
    if (this.eventMarkAttendanceForm.valid) {
      const formData = new FormData();
      let participantIndex = 0; // Use a single, running index for all participants

      const declarationAccepted = this.eventMarkAttendanceForm.get(
        'declarationAccepted',
      )?.value;




      this.existingParticipants.forEach((participant: any) => {
        formData.append(
          `selectedParticipants[${participantIndex}].UdyamRegistrationNumber`,
          participant.UdyamRegistrationNumber,
        );
        formData.append(
          `selectedParticipants[${participantIndex}].ParticipantName`,
          participant.ParticipantName,
        );
        formData.append(
          `selectedParticipants[${participantIndex}].NameOfEnterprise`,
          participant.NameOfEnterprise,
        );
        formData.append(
          `selectedParticipants[${participantIndex}].MobileNumber`,
          participant.MobileNumber,
        );
        formData.append(
          `selectedParticipants[${participantIndex}].EnrollmentId`,
          participant.EnrollmentId,
        );
        formData.append(
          `selectedParticipants[${participantIndex}].IsChecked`,
          participant.IsChecked,
        );
        participantIndex++;
      });

      

      // If selectedParticipants is not empty, append them as well
      if (this.selectedParticipants.length > 0) {
        this.selectedParticipants.forEach((participant: any) => {
          formData.append(
            `selectedParticipants[${participantIndex}].UdyamRegistrationNumber`,
            participant.UdyamRegistrationNumber,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].ParticipantName`,
            participant.ParticipantName,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].NameOfEnterprise`,
            participant.NameOfEnterprise,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].MobileNumber`,
            participant.MobileNumber,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].EnrollmentId`,
            participant.EnrollmentId,
          );
          formData.append(
            `selectedParticipants[${participantIndex}].IsChecked`,
            participant.IsChecked,
          );
          participantIndex++;
        });
      }

      formData.append('UniqueEventId', this.eventId);
      //formData.append('IsAttendanceSubmitted', 'false');
      formData.append('key', key);
      // Append the declarationAccepted value to the FormData object
      formData.append('declarationAccepted', declarationAccepted);

console.log('declarationAccepted:', formData);
      this.apiService
        .postRequest(API_ENDPOINTS.MSSIDC.SAVE_MSSIDC_EVENT_ATTENDANCE, formData)
        .subscribe(
          (result: any) => {
            this.toastrService.success(
              'Attendance marked successfully!',
              'Good job!',
            );
        this.dialogRef.close(true); 
            // this.router.navigate(['/Msme-Attendance-List']);
          },
          //error => {
          //  this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
          //  //console.error('Error saving data:', error);
          //}
        );
    } else {
      this.eventMarkAttendanceForm.markAllAsTouched();

      // Check if the declaration control is currently invalid AND we are showing the no-participants message
      const declarationControl = this.eventMarkAttendanceForm.get(
        'declarationAccepted',
      );

      if (this.showNoParticipantsMessage && declarationControl?.invalid) {
        // Show a specific error message for the declaration
        this.toastrService.error(
          'Please check the declaration checkbox to confirm the event status.',
          'Confirmation Required',
        );
      } else {
        // Fallback for other validation errors (e.g., if you add other required fields)
        this.toastrService.error(
          'Please fix all indicated errors before submitting.',
          'Validation Failed',
        );
      }
      return;
    }
  }


  confirmSubmit() {
    if (
      window.confirm(
        'Are you sure you want to submit the attendance? Once it is submitted no further change will be allowed',
      )
    ) {
      //this.onSubmitForSubmitButton(); // Call the original onSubmit method
      this.isAttendanceSubmitted = true;
    }
  }
}
